/**
 * 引导用户去“我的”页面，收取金币
 */
import React, { Component } from "react";
import ReactDOM, { render } from "react-dom";
import lang from "../lang/index";
import DialogHOC from "./dialog-hoc";
import api from "../global/api";
import http from "../global/http";
import cache from "../global/cache";
import notification from "c-notification";
import loading from "c-loading";
import { doInvoicing } from "../service/api/index";

class Dialog extends Component {
    static defaultProps = {
        orderData: {},
    };
    constructor(props) {
        super(props);
        this.state = {
            invoiceType: 2,
            canSubmit: false,
        };
    }

    changeType(type) {
        this.setState(
            {
                invoiceType: type,
                canSubmit: false,
            },
            () => {
                //this.checkform();
            }
        );
    }
    checkform = () => {
        let invoiceType = this.state.invoiceType;
        let canSubmit = false;
        let emailReg =
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        if (invoiceType === 2) {
            let email = this.trimSpace(this.refs.email.value);
            canSubmit = email.length > 0; //emailReg.test(email) ;
        } else {
            let mobileReg = /^09[0-9]{8}$/;

            let email = this.trimSpace(this.refs.email.value);
            let mobile = this.trimSpace(this.refs.mobile.value);
            let address = this.trimSpace(this.refs.address.value);
            let realname = this.trimSpace(this.refs.realname.value);

            //canSubmit =   mobileReg.test(mobile) && address && realname);
            canSubmit =
                email.length > 0 &&
                mobile.length > 0 &&
                address.length > 0 &&
                realname.length > 0;
        }
        if (canSubmit) {
            this.setState({ canSubmit: true });
            //$('.btn').removeClass('btn-noclick');
        } else {
            this.setState({ canSubmit: false });
            //$('.btn').addClass('btn-noclick');
        }
        this.canSubmit = canSubmit;
    };
    trimSpace(str) {
        return str.replace(/(^\s*)|(\s*$)/g, "");
    }

    handleSubmit = () => {
        let emailReg =
            /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
        let mobileReg = /^09[0-9]{8}$/;

        if (this.canSubmit) {
            if (!emailReg.test(this.trimSpace(this.refs.email.value))) {
                notification.simple("邮箱格式错误");
                return;
            }
            if (
                this.state.invoiceType == 1 &&
                !mobileReg.test(this.trimSpace(this.refs.mobile.value))
            ) {
                notification.simple("电话号码格式错误");
                return;
            }

            loading.show({
                text: "loading",
            });
            let data, typeData;
            let userInfo = this.props.userInfo;
            let orderData = this.props.orderData;
            data = {
                uid: window.longToString(userInfo.uid),
                platform: "uplive",
                order_id: orderData.orderId,
                // pay_no:orderData.accountId,
                pay_bank: orderData.orderBank,
                email: this.refs.email.value,
            };
            console.log(this.state.invoiceType);
            if (this.state.invoiceType == 2) {
                typeData = {
                    invoice_type: 2,
                };
            } else {
                typeData = {
                    invoice_type: 1,
                    real_name: this.refs.realname.value,
                    address: this.refs.address.value,
                    mobile: this.refs.mobile.value,
                };
            }

            doInvoicing(Object.assign(data, typeData)).then((res) => {
                loading.hide();
                if (res.return_code == "SUCCESS") {
                    this.props.handleCancel();
                    orderData.accountId = res.pay_no;

                    $.channel.emit("bankComplete", orderData);
                } else {
                }
            });
        }
    };

    render() {
        let invoiceType = this.state.invoiceType;
        let $inputContentDom = (
            <div className="input-content">
                <input
                    type="text"
                    key="1"
                    placeholder={lang.template("请输入e-mail地址")}
                    name="email"
                    onChange={this.checkform}
                    ref="email"
                />
            </div>
        );
        if (invoiceType == 1) {
            $inputContentDom = (
                <div className="input-content">
                    <input
                        key="2"
                        type="text"
                        placeholder={lang.template("请输入真实姓名")}
                        name="realname"
                        ref="realname"
                        onChange={this.checkform}
                    />
                    <input
                        key="3"
                        type="text"
                        placeholder={lang.template("请输入住宅地址")}
                        name="address"
                        ref="address"
                        onChange={this.checkform}
                    />
                    <input
                        key="4"
                        type="text"
                        placeholder={lang.template("请输入联系电话")}
                        name="mobile"
                        ref="mobile"
                        onChange={this.checkform}
                    />
                    <input
                        key="5"
                        type="text"
                        placeholder={lang.template("请输入e-mail地址")}
                        name="email"
                        ref="email"
                        onChange={this.checkform}
                    />
                </div>
            );
        }
        let $btnDom = (
            <div className="btn btn-noclick" onClick={this.handleSubmit}>
                {lang.template("提交，去支付")}
            </div>
        );
        if (this.state.canSubmit) {
            $btnDom = (
                <div className="btn" onClick={this.handleSubmit}>
                    {lang.template("提交，去支付")}
                </div>
            );
        }

        return (
            <div className="popup-wrapper">
                <div className="box-hd">
                    <div className="title">{lang.template("发票信息")}</div>
                    <div
                        className="close"
                        onClick={this.props.handleCancel}
                    ></div>
                </div>
                <div className="content">
                    <div className="tab">
                        <div
                            className="cishan"
                            onClick={() => {
                                this.changeType(2);
                            }}
                        >
                            <span
                                className={invoiceType === 2 ? "selected" : ""}
                            >
                                {lang.template("慈善捐款")}
                            </span>
                        </div>
                        <div
                            className="need-invoice"
                            onClick={() => {
                                this.changeType(1);
                            }}
                        >
                            <span
                                className={invoiceType === 1 ? "selected" : ""}
                            >
                                {lang.template("索取发票")}
                            </span>
                        </div>
                    </div>
                    {$inputContentDom}
                    <div className="notice">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: lang.template("慈善捐赠解释"),
                            }}
                        ></p>
                        <p
                            dangerouslySetInnerHTML={{
                                __html: lang.template("索取发票解释"),
                            }}
                        ></p>
                    </div>
                </div>
                <div className="box-fd">{$btnDom}</div>
            </div>
        );
    }
}

const NewDialog = DialogHOC(Dialog);

module.exports = {
    create: function (cfg) {
        cfg = cfg || {};

        if (this.layer) {
            this.destroy();
        }
        var mountNode = this.createMountNode();

        this.layer = ReactDOM.render(
            <NewDialog {...cfg} onHide={this.onHide.bind(this)} />,
            mountNode
        );
    },
    onHide: function () {
        this.destroy();
    },
    // 创建组件插入的DOM节点
    createMountNode: function () {
        this.mountNode = document.createElement("div");
        $(document.body).append(this.mountNode);
        return this.mountNode;
    },
    destroy: function () {
        ReactDOM.unmountComponentAtNode(this.mountNode);
        $(this.mountNode).remove();
        delete this.layer;
    },
};



// WEBPACK FOOTER //
// ./js/popup/dialog-invoice.js